import { AxiosError } from "axios";

import { api } from "@/lib/axios";

export type LastSales = {
	count_sales: number;
	total_commission: string;
};

interface SuccessResponse {
	status: "success";
	data: LastSales;
}

interface ErrorResponse {
	status: "error";
	errors: { [key: string]: string };
}

type GetLastSalesResponse = SuccessResponse | ErrorResponse;

export async function getLastSales(): Promise<GetLastSalesResponse> {
	try {
		const { data } = await api.get("/user/latest-sales");

		return {
			status: "success",
			data: data?.data,
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response?.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
